import { PartnerFirmsPage } from "@/components/features/referrals/PartnerFirmsPage";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/referrals/partner-firms")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();
  return hasPagePermission(PAGE_PERMISSION_KEYS.referralsAll) ? (
    <PartnerFirmsPage />
  ) : (
    <GlobalNotAuthorized />
  );
}
